import * as React from 'react';

import { SVGProps } from '../../types';

const COLORS = {
  'grey-600': '#ABB4BD',
  'grey-900': '#5C6975',
};

type TimerCompletedState = 'active' | 'warning' | 'critical';

type IconTimerCompletedSvgProps = SVGProps & {
  state: TimerCompletedState;
};

export const IconTimerCompletedSvg = ({
  title,
  titleId,
  state,
  ...props
}: IconTimerCompletedSvgProps) => {
  const clockColor = COLORS['grey-600'];
  const checkmarkColor = COLORS['grey-900'];

  return (
    <svg
      width={36}
      height={36}
      viewBox="0 0 36 36"
      fill="none"
      focusable="false"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <rect width="36" height="36" rx="4" fill="white" />

      {/* Clock circle - always grey-600 */}
      <circle
        cx="18"
        cy="19"
        r="9"
        stroke={clockColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Top line */}
      <line
        x1="15.75"
        y1="7.25"
        x2="20.25"
        y2="7.25"
        stroke={clockColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Top right line */}
      <line
        x1="25.4239"
        y1="9.80762"
        x2="27.1917"
        y2="11.5754"
        stroke={clockColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* State-specific indicators - all grey-600 */}
      {state === 'active' && (
        <path
          d="M13.8656 15.6589C13.6903 15.4334 13.7102 15.1126 13.9122 14.9107C14.1142 14.7087 14.435 14.6887 14.6605 14.8641L19.4457 18.5859C20.0744 19.0749 20.1323 20.0043 19.5691 20.5675C19.0059 21.1307 18.0765 21.0728 17.5875 20.4441L13.8656 15.6589Z"
          fill={clockColor}
        />
      )}

      {state === 'warning' && (
        <path
          d="M11.3231 18.0033C11.7567 15.0732 14.0732 12.7567 17.0033 12.3231C17.5497 12.2422 18 12.6967 18 13.249V18.7518C18 18.8899 17.8881 19 17.75 19L12.25 19C11.6977 19 11.2422 18.5497 11.3231 18.0033Z"
          fill={clockColor}
        />
      )}

      {state === 'critical' && (
        <path
          d="M13.9831 13.5744C14.8529 12.9295 15.8831 12.4888 17.003 12.323C17.5494 12.2422 17.9995 12.6977 17.9995 13.25L17.9995 18.3964C17.9995 18.6192 17.7302 18.7307 17.5728 18.5732L13.9337 14.9341C13.5431 14.5436 13.5395 13.9034 13.9831 13.5744Z"
          fill={clockColor}
        />
      )}

      {/* Checkmark overlay - always present */}
      <rect x="18" y="15" width="18" height="18" rx="9" fill="white" />
      <path
        d="M22 23.2105L25.871 27L32 21"
        stroke={checkmarkColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
